(() => {
  if (window.ggNavbarInitialized) return;
  window.ggNavbarInitialized = true;
  let returnFocus, previousOverflow;
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-search-open]');
    const dialog = document.querySelector('#gg-search');
    if (opener && dialog && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      event.preventDefault(); returnFocus = opener; previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden'; dialog.showModal();
      dialog.querySelector('[name=q]').focus();
    }
    if (event.target.closest('[data-search-close]')) dialog?.close();
  });
  const dialog = document.querySelector('#gg-search');
  const menu = document.querySelector('#gg-menu');
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-menu-open]');
    if (opener && menu) { returnFocus = opener; previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; menu.showModal(); menu.querySelector('#gg-menu-title')?.focus({preventScroll:true}); }
    if(event.target.closest('[data-menu-close]')) menu?.close();
  });
  menu?.addEventListener('close', () => {document.body.style.overflow = previousOverflow || ''; returnFocus?.focus({preventScroll:true});});
  menu?.addEventListener('click', event => {if(event.target === menu && event.clientX > menu.getBoundingClientRect().right) menu.close();});
  const input = dialog?.querySelector('[name=q]');
  const results = document.querySelector('#gg-search-results');
  let searchTimer, searchRequest;
  input?.addEventListener('input', () => {
    clearTimeout(searchTimer); searchRequest?.abort(); results.replaceChildren();
    const query = input.value.trim(); if(!query) return;
    results.textContent = 'Searching…';
    searchTimer = setTimeout(async () => {
      searchRequest = new AbortController();
      try {
        const params = new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'5','resources[options][fields]':'title'});
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'search/suggest.json?' + params, {signal:searchRequest.signal});
        if(!response.ok) throw new Error('Search unavailable');
        const data = await response.json(); if(input.value.trim() !== query) return;
        results.replaceChildren();
        const products = data.resources.results.products;
        products.forEach(product => {
          const link = document.createElement('a'); link.className = 'gg-search-result'; link.href = product.url;
          if(product.image) {const img = document.createElement('img'); img.src = product.image; img.alt = ''; link.append(img);}
          const title = document.createElement('span'); title.textContent = product.title; link.append(title); results.append(link);
        });
        if(!products.length) results.textContent = 'No products found. Try another search.';
      } catch(error) {if(error.name !== 'AbortError' && input.value.trim() === query) results.textContent = 'Press Enter to see search results.';}
    }, 250);
  });
  dialog?.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow || '';
    returnFocus?.focus({preventScroll:true});
  });
  dialog?.addEventListener('click', event => {
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientY > rect.bottom || event.clientX > rect.right) dialog.close();
    }
  });
  function counts(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count > 99 ? '99+' : cart.item_count; el.hidden = cart.item_count === 0;
      el.closest('a')?.setAttribute('aria-description', `${cart.item_count} items in cart`);
    });
    document.querySelectorAll('[data-variant-cart-count]').forEach(el => {
      const count = cart.items.reduce((sum,item) => sum + (String(item.variant_id) === el.dataset.variantId ? item.quantity : 0),0);
      el.textContent = `(${count} in cart)`; el.hidden = count === 0;
    });
  }
  document.addEventListener('grillgleam:cart-updated', event => counts(event.detail));
  async function refresh() {
    try { const r = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js'); if(r.ok) counts(await r.json()); } catch (_) { /* Keep server-rendered counts if offline. */ }
  }
  refresh();
  window.addEventListener('pageshow', event => { if(event.persisted) refresh(); });
})();
